import { emptyValue, Value } from "../../cardano/entities/value";
import { OrderKind } from "../models/opRequests";
export function mkAmmActions(outputs, uiRewardAddr) {
    return new DefaultAmmActions(outputs, uiRewardAddr);
}
class DefaultAmmActions {
    constructor(outputs, uiRewardAddr) {
        this.outputs = outputs;
        this.uiRewardAddr = uiRewardAddr;
    }
    createOrder(req, ctx) {
        const orderCandidate = () => {
            switch (req.kind) {
                case OrderKind.Deposit:
                    return this.outputs.deposit(req);
                case OrderKind.Redeem:
                    return this.outputs.redeem(req);
                case OrderKind.Swap:
                    return this.outputs.swap(req);
            }
        };
        const outputs = [orderCandidate()];
        if (req.uiFee > 0n)
            outputs.push({ value: Value(req.uiFee), addr: this.uiRewardAddr });
        return {
            inputs: ctx.inputs,
            outputs: outputs,
            valueMint: emptyValue,
            changeAddr: ctx.changeAddr,
            ttl: ctx.ttl
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYW1tQWN0aW9ucy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hbW0vaW50ZXJwcmV0ZXJzL2FtbUFjdGlvbnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUFDLFVBQVUsRUFBRSxLQUFLLEVBQUMsTUFBTSw4QkFBOEIsQ0FBQTtBQUU5RCxPQUFPLEVBQUMsU0FBUyxFQUFlLE1BQU0sc0JBQXNCLENBQUE7QUFPNUQsTUFBTSxVQUFVLFlBQVksQ0FBQyxPQUFtQixFQUFFLFlBQWtCO0lBQ2xFLE9BQU8sSUFBSSxpQkFBaUIsQ0FBQyxPQUFPLEVBQUUsWUFBWSxDQUFDLENBQUE7QUFDckQsQ0FBQztBQUVELE1BQU0saUJBQWlCO0lBQ3JCLFlBQTRCLE9BQW1CLEVBQWtCLFlBQWtCO1FBQXZELFlBQU8sR0FBUCxPQUFPLENBQVk7UUFBa0IsaUJBQVksR0FBWixZQUFZLENBQU07SUFBRyxDQUFDO0lBRXZGLFdBQVcsQ0FBQyxHQUFpQixFQUFFLEdBQWM7UUFDM0MsTUFBTSxjQUFjLEdBQUcsR0FBRyxFQUFFO1lBQzFCLFFBQVEsR0FBRyxDQUFDLElBQUksRUFBRTtnQkFDaEIsS0FBSyxTQUFTLENBQUMsT0FBTztvQkFDcEIsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQTtnQkFDbEMsS0FBSyxTQUFTLENBQUMsTUFBTTtvQkFDbkIsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQTtnQkFDakMsS0FBSyxTQUFTLENBQUMsSUFBSTtvQkFDakIsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQTthQUNoQztRQUNILENBQUMsQ0FBQTtRQUVELE1BQU0sT0FBTyxHQUFHLENBQUMsY0FBYyxFQUFFLENBQUMsQ0FBQTtRQUNsQyxJQUFJLEdBQUcsQ0FBQyxLQUFLLEdBQUcsRUFBRTtZQUFFLE9BQU8sQ0FBQyxJQUFJLENBQUMsRUFBQyxLQUFLLEVBQUUsS0FBSyxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQUMsRUFBRSxJQUFJLEVBQUUsSUFBSSxDQUFDLFlBQVksRUFBQyxDQUFDLENBQUE7UUFFcEYsT0FBTztZQUNMLE1BQU0sRUFBRSxHQUFHLENBQUMsTUFBTTtZQUNsQixPQUFPLEVBQUUsT0FBTztZQUNoQixTQUFTLEVBQUUsVUFBVTtZQUNyQixVQUFVLEVBQUUsR0FBRyxDQUFDLFVBQVU7WUFDMUIsR0FBRyxFQUFFLEdBQUcsQ0FBQyxHQUFHO1NBQ2IsQ0FBQTtJQUNILENBQUM7Q0FDRiJ9